export default "__VITE_ASSET__3313ff45__"